<template>
  <div class="filter-search-box filter--btn advanced input-active" id="search_filed_box" v-if="isSearch">
    <label
      for="filter_search_box_input"
      class="filter-search-box-label"
      id="filter-search-box-label"
      :class="{ active: true }"
      @click="handleOnFocus"
    >
      <span class="search-query-prepend" v-if="searchQuery"> {{ searchQuery.text }} </span>

      <v-menu
        class="advanced-search-menu"
        nudge-bottom="7px"
        :rounded="false"
        offset-overflow
        bottom
        offset-y
        attach="#search_filed_box"
      >
        <template v-slot:activator="{ on, attrs }">
          <input
            v-model="query"
            :tabindex="tabindex"
            class="input-search advanced"
            type="search"
            id="filter_search_box_input"
            ref="filterSearchRef"
            v-bind="attrs"
            v-on="!searchQuery ? on : ''"
            @keyup="handleOnSearch"
            :placeholder="$t('search_text_placeholder', { placeholder })"
            autocomplete="off"
          />
        </template>

        <v-list>
          <v-list-item
            @click="handleOnSelect(column)"
            v-for="(column, index) in searchableColumns"
            :key="`item-${index}`"
          >
            <div class="ellipsis">{{ column.text }} = {{ query }}</div>
          </v-list-item>
        </v-list>
      </v-menu>

      <div class="search-prepend-actions">
        <FIcon
          v-if="!searchQuery"
          :name="'filter-search'"
          class="close-action active"
          color="#546e7a"
          @click.native="handleOnInputFocus"
        />
        <FIcon
          v-if="!!searchQuery"
          :name="'close'"
          class="close-action active"
          color="#546e7a"
          size="1.1rem"
          @click.native="handleResetSearch"
        />
      </div>
    </label>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import debounce from "lodash/debounce";

export default {
  name: "AdvancedFilterSearch",

  data: () => ({
    isLoading: true,
    query: "",
    searchQuery: "",
    searchableColumns: "",
    isActive: false,
  }),

  props: {
    tabindex: {
      type: String,
      default: "1",
    },

    placeholder: {
      default: "",
      type: String,
    },
    isNestedSearch: {
      type: Boolean,
      default: false,
    },
    items: {
      type: Array,
      default: () => [],
    },
    textSuffix: {
      type: String,
      default: "is",
    },
    columns: {
      type: [Array, null],
      default: null,
    },
  },

  computed: {
    ...mapGetters({
      filter: "App/filter",
    }),

    /**
     * Get is form able to search
     * @return {Boolean}
     */
    isSearch() {
      return !this.isLoading && !!this.filter;
    },

    /**
     * Handle on search query "KeyUp Event"
     * @return {void}
     */
    handleOnSearch() {
      return debounce(() => {
        if (!this.query) {
          this.$refs?.filterSearchRef?.click();
        }
        if (!this.searchQuery) {
          return;
        }
        if (this.isNestedSearch) {
          this.filter.nestedQuery = this.query;
          return;
        }

        this.filter.query = this.query;
      }, 500);
    },
  },

  mounted() {
    this.$nextTick(() => {
      this.searchableColumns = this.columns.filter((column) => column.searchable);
      this.isLoading = false;
    });
  },

  methods: {
    /**
     * handle on input focus
     * @return {void}
     */
    handleOnInputFocus() {
      this.$refs?.filterSearchRef?.focus();
    },

    /**
     * Handle on reset search query
     * @return {void}
     */
    handleResetSearch() {
      this.query = "";
      this.$refs?.filterSearchRef?.focus();
      this.filter.query = "";
      this.filter.nestedQuery = "";
      this.searchQuery = "";
      this.filter.seaechParamater = this.searchQuery;
      this.handleOnInputFocus();
      this.$refs?.filterSearchRef?.blur();
    },

    /**
     * Handle on on focus
     * @return {void}
     */
    handleOnFocus(e) {
      e.preventDefault();
      //   this.$refs?.filterSearchRef?.select();
      this.$nextTick(() => {
        this.isActive = true;
      });
    },

    /**
     * Handle on on focus out
     * @return {void}
     */
    handleOnFocusOut(e) {
      e.preventDefault();

      this.$nextTick(() => {
        if (!!this.isActive && !this.query) {
          this.isActive = false;
        }
      });
    },

    /**
     * Handle on on focus out
     * @return {void}
     */
    handleOnSelect(value) {
      this.searchQuery = value;
      this.filter.seaechParamater = `${this.searchQuery.value}__includes`;
      if (this.searchQuery.search_suffix) {
        this.filter.seaechParamater = `${this.searchQuery.value}${this.searchQuery.search_suffix}__includes`;
      }
      this.filter.query = this.query;

      this.handleOnInputFocus();
    },
  },

  directives: {
    /**
     * directive to handel user click out of the auto complete box
     * @directive
     */
    "handle-click-outside": {
      bind: (el, binding) => {
        const { bubble } = binding.modifiers;
        const clickHandler = (e) => {
          if (
            bubble ||
            (!el.contains(e.target) &&
              el !== e.target &&
              e.target.id !== "search_filed_box" &&
              e.target.id !== "search_filed_box_clear")
          ) {
            binding.value(e);
            return true;
          }
          return false;
        };
        el.__vueHandleClickOutside__ = clickHandler;
        document.addEventListener("click", clickHandler, false);
      },

      unbind: (el) => {
        document.removeEventListener("click", el?.__vueHandleClickOutside__);
        el.__vueHandleClickOutside__ = null;
      },
    },
  },
};
</script>
